<div class="wrapper" [class.invalid]="!product()?.isAvailable">
    <div class="inner">
        <div class="image">
            <lib-light-carousel [images]="vm().smallImagesForCards" [label]="product()?.name"></lib-light-carousel>
        </div>
        <div class="details">
            <div class="main-info">
                <p class="main-info__name body-0">
                    <span>
                        {{ product()?.brandName }}
                    </span>
                    <span>
                        @if (isProcessedProduct(product()) && hasEngraving(product())) {
                            Personalized {{ product()?.name }}
                        } @else {
                            {{ product()?.name }}
                        }
                    </span>
                </p>
                <div class="meta-info">
                    <!-- <div class="meta-info__item">
            Product variant: {{product().variant}}
          </div> -->
                    <p class="meta-info__item body-1">Quantity: {{ product()?.quantity }}</p>
                    @if (product().estimatedShippingDays) {
                        <p class="meta-info__item body-2">
                            {{ product().estimatedShippingDays }}
                        </p>
                    }
                    <!-- <div class="meta-info__item">Microcopy</div> -->
                </div>
                @if (hasEngraving(product())) {
                    <div class="engraving-details">
                        <button
                            class="view-engraving-btn"
                            type="button"
                            [attr.aria-label]="'View engraving details for ' + product()?.name"
                            (click)="viewEngravingDetails(product())"
                        >
                            View Details
                        </button>
                    </div>
                }
            </div>
            <div class="price-container">
                <div class="price">
                    <p class="primary-cta">{{ vm().displayNewPrice | currency }}</p>
                    @if (userService.canRedeemPoints()) {
                        <p class="body-0 price__points">or {{ vm().displayNewPoints | appDigitsGrouping }} pts</p>
                    }
                </div>

                @if (vm().shouldShowOldPoints && userService.canRedeemPoints()) {
                    <lib-cart-old-price [points]="vm().displayOldPoints!" [price]="vm().displayOldPrice" />
                }
            </div>
        </div>
    </div>

    <div class="apple-care-slot">
        <ng-content select="[cart-summary-apple-care]"></ng-content>
    </div>

    @if (!product()?.isAvailable) {
        <lib-alert-message
            text="This item is no longer available. Please remove it from your cart"
            type="error"
        ></lib-alert-message>
    }
</div>
